import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { NzMessageService } from 'ng-zorro-antd'
import { UtilsService } from 'src/utils/utils.service'
import { CustomerService } from '../customer/customer.service'
import { ProductService } from './product.service'

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
})
export class ProductComponent implements OnInit {
  constructor(private customerService:CustomerService,private utilsService: UtilsService, private route: ActivatedRoute, private service: ProductService, private message: NzMessageService) {}
  selectedValue = null
  name = ''
  total = 0
  size = 10
  page = 1
  listOfAllData = []
  nzOptions = []
  classifyId = null
  params = null
  loading = false
  ngOnInit() {
    this.getClassifyList()
    this.route.queryParams.subscribe((params) => {
      console.log('接收的参数--->', { ...params })
      this.params = params
      this.search()
    })
  }

  async search() {
    console.log(this.name, this.selectedValue)
    try {
      this.loading = true
      const params = {
        classifyId: this.classifyId || '',
        title: this.name || '',
        page: this.page || 1,
        size: 10,
      }
      const res = await this.service.getProductList(params)
      res.data.forEach((element) => {
        const pic = this.utilsService.getJSONParse(element.pic, [])
        if (Array.isArray(pic)) {
          element.pic = pic[0]
        } else {
          element.pic = pic
        }
      })
      console.log(res)
      this.total = res.total
      this.listOfAllData = res.data
      this.loading = false
    } catch (error) {
      this.message.error(error.message)
      this.loading = false
    }
  }

  // 获取分类
  async getClassifyList(classifyId?): Promise<void> {
    try {
      const params = {
        type: 2,
      }
      const { data } = await this.service.getClassifys(params)
      const classifyList = data.classifyList
      this.nzOptions = this.utilsService.treeSelect(classifyList)
    } catch (error) {
      console.log('getClassifyList err is', error)
    }
  }
  reset() {
    this.selectedValue = null
    this.name = ''
  }

  pageChange(event): void {
    this.page = event
    this.search()
  }
  onChanges(values: string[]): void {
    this.classifyId = !values.length ? '' : values[values.length - 1];
  }
  send(item) {
    let data = {
      // 要发送的卡片数据对象
      showCardInfoMsg: '1',
      title: item.title,
      sub_title: '',
      img: item.pic.image,
      // attr_one: { color: '#000000', content: 'X1' },
      // attr_two: { color: '#000000', content: '已发货' },
      price: '￥'+item.showPrice,
      other_title_one: '',
      other_title_two: '',
      other_title_three: '',
      target: 'https://dev.rltab.ptteng.com/h5Jump/',
      tags: [
        // {
        //   label: '按钮名称', // 按钮名字
        //   url: 'https://www.7moor.com', // 非必填，若没有focusIframe字段或没有匹配到对应的tab页，以新窗口方式打开配置的url链接；
        //   focusIframe: 'iframe名称', // 定位到iframe的标识，与后台配置的tab页名称匹配
        //   showRange: 'visitor', //该字段不存在(兼容老客户)或者为all访客端座席端都展示， seats座席端展示，visitor访客端展示
        // },
        // {
        //   label: '按钮名称1',
        //   focusIframe: 'iframe名称1',
        //   showRange: 'visitor', //该字段不存在(兼容老客户)或者为all访客端座席端都展示， seats座席端展示，visitor访客端展示
        // },
      ],
    }
    console.log('发送的商品参数',item)
    console.log('data定制--->',data);
    window.parent.postMessage(data, '*')
  }

  async login() {
    try {
      const params = {
        exten: this.params.exten,
        token: this.params.token,
        tokenId: this.params.tokenId
      }
      const { data } = await this.customerService.login(params)
      localStorage.setItem('merchantId',data.merchants[0].id)
      localStorage.setItem('token', data.token)
    } catch (error) {
      this.message.error(error.message)
    }
  }
}
